import React, { forwardRef, lazy } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { filter } from "lodash";
import moment from "moment/moment";
import SessionDetails from "./sessionDetails";
import { dayAppointmentsState } from "../../../../../../../store/reducers/appointments";
import {
  COLUMN_GAP,
  useDailyCalendarStyles,
} from "../../edReviewCalendarDaily";
import { Grid } from "@mui/material";


const ColumnHeader = forwardRef(({ columns, columnHeaderStyles }, ref) => {
  const classes = useDailyCalendarStyles();

  const appointmentSlots = useSelector(dayAppointmentsState);

  return (
    <Grid container className={classes.columnHeader}>
      <Grid container item xs={12} ref={ref} style={{ gap: COLUMN_GAP }} flexWrap='nowrap'>
        {columns.map((col, index) => {
          const nextToBeSeen = filter(
            appointmentSlots,
            (slot) =>
              slot?.assignedSession === col?.sessionId &&
              moment(slot?.startDate).isAfter(moment(), "minute") &&
              slot.status !== "locked",
          ).at(0);

          return (
            <SessionDetails
              session={col}
              key={col?.sessionId}
              nextToBeSeen={nextToBeSeen}
              showNextToBeSeen={!!nextToBeSeen} // Temporary
              columnHeaderStyles={columnHeaderStyles}
            />
          );
        })}
      </Grid>
    </Grid>
  );
});

ColumnHeader.propTypes = {
  columns: PropTypes.array,
  columnHeaderStyles: PropTypes.object,
};

export default ColumnHeader;
